export const apiUrl = 'https://pokeapi.co/api/v2';
export const prodEndpoint = 'fill me up';
export const pagination = 4;